import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "@/components/shared/Navbar";
import { Footer } from "@/components/shared/Footer";
import { ScrollToTop } from "@/components/shared/ScrollToTop";
import { WhatsAppButton } from "@/components/shared/WhatsAppButton";

export function PublicLayout() {
  const location = useLocation();

  useEffect(() => {
    // Update page title based on route
    const titles: Record<string, string> = {
      "/": "Allo Artisan & Trouvez un artisan de confiance en 5 minutes",
      "/admin": "Dashboard Admin Allo Artisan",
    };
    document.title = titles[location.pathname] || "Allo Artisan";
  }, [location]);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
      <ScrollToTop />
    </div>
  );
}
